import axiosInstance from '../axiosInterceptor/axiosInstance'

const assignTeamToSeason = async (data) => {
  const { orgId, seasonId, teamId, name } = data
  const url = `v1/orgs/${orgId}/season-teams/assign-season`
  return axiosInstance.post(url, { seasonId, teamId, name })
}

export default assignTeamToSeason
